<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['feature']),
  },
}
</script>
